import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import times from 'lodash/times';
import { useTranslation } from 'react-i18next';
import {
    CalendarContainer,
    Col,
    Container,
    DayCell,
    DayRow,
    HeaderCell,
    HeaderRow,
    LoaderContainer,
    Row
} from './styled';
import {
    Loader,
    Text
} from 'mol-ui';

const Calendar = ({
    highlightDays = [],
    loading,
    month,
    onDaySelect,
    title,
    year
})  => {

    const { t } = useTranslation();

    const handleClick = day => {
        onDaySelect(moment(`${ year }-${ month }-${ day }`, 'YYYY-MM-DD'));
    };

    const propMonth = month ?? moment().month() + 1;
    const propYear = year ?? moment().year();
    const daysInPrevMonth = moment().month(propMonth - 1).year(propYear).add(-1, 'month').daysInMonth();
    const daysInMonth = moment().month(propMonth - 1).year(propYear).daysInMonth();
    const firstWeekDay = moment().month(propMonth - 1).year(propYear).startOf('month').isoWeekday() - 1;
    const lastWeekDay = moment().month(propMonth - 1).year(propYear).endOf('month').isoWeekday() - 1;
    const renderedWeeks = (firstWeekDay + daysInMonth + 6 - lastWeekDay) / 7;

    return (
        <Container>
            <Row>
                <Col>
                    <Text
                        fontSize="18px"
                        margin="0px 0px 20px 0px"
                        textAlign="center"
                    >
                        { title }
                    </Text>
                    {
                        !loading
                            ? <CalendarContainer>
                                <HeaderRow>
                                    {
                                        [t('Lun'), t('Mar'), t('Mié'), t('Jue'), t('Vie'), t('Sáb'), t('Dom')].map((day, index) =>
                                            <HeaderCell key={ index }>{ day }</HeaderCell>
                                        )
                                    }
                                </HeaderRow>
                                <DayRow>
                                    {
                                        times(firstWeekDay, i =>
                                            <DayCell key={ `prev-${ i }` } lines={ renderedWeeks } outofrange="true">
                                                { daysInPrevMonth - firstWeekDay + i + 1 }
                                            </DayCell>
                                        )
                                    }
                                    {
                                        times(daysInMonth, i => {
                                            const highlighted = highlightDays.includes(i + 1);
                                            return (
                                                <DayCell
                                                    highlighted={ highlighted }
                                                    key={ i }
                                                    lines={ renderedWeeks }
                                                    onClick={ () => handleClick(i + 1) }>
                                                    { i + 1 }
                                                </DayCell>
                                            );
                                        }
                                        )
                                    }
                                    {
                                        times(6 - lastWeekDay, i =>
                                            <DayCell key={ `next-${ i }` } lines={ renderedWeeks } outofrange="true">
                                                { i + 1 }
                                            </DayCell>
                                        )
                                    }
                                </DayRow>
                            </CalendarContainer>
                            : <LoaderContainer>
                                <Loader active size={ 12 } />
                            </LoaderContainer>
                    }
                </Col>
            </Row>
        </Container>
    );

};

Calendar.propTypes = {
    highlightDays: PropTypes.arrayOf(PropTypes.number),
    loading: PropTypes.bool,
    month: PropTypes.number,
    onDaySelect: PropTypes.func,
    title: PropTypes.string,
    year: PropTypes.number
};

export default Calendar;
